module.exports = __webpack_public_path__ + "static/media/nc3.8ae31d93.png";